import { formatCurrency } from 'common/FormatUtilities';
import React from 'react';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import style from 'styled-components';
import { Font, Spacing } from 'web-common/src/shared/styles';

const DishPriceText = style(VerticallyCenteredText)`
  color: {Colors.GRAY_100};
  margin: ${Spacing.NONE} ${Spacing.SINGLE} ${Spacing.NONE} ${Spacing.NONE};
  font-size: 14px;
  font-weight: ${Font.Weight.SEMI_BOLD}
`;

interface IProps {
  price: number;
}

export const DishPrice: React.FC<IProps> = ({ price }) => (
  <DishPriceText data-cy='foodItem-cost'>{formatCurrency(price)}</DishPriceText>
);
